<template>
	<div>
		<ul class="settings-subnav">
			<li>
				<button type="button" :class="{ active: sub === 'roles' }" @click="sub = 'roles'">
					<i class="fas fa-user-shield me-1"></i> Roles
				</button>
			</li>
			<li>
				<button type="button" :class="{ active: sub === 'permissions' }" @click="sub = 'permissions'">
					<i class="fas fa-key me-1"></i> Permissions
				</button>
			</li>
		</ul>

		<Roles v-if="sub === 'roles'" />
		<PermissionsSettings v-if="sub === 'permissions'" />
	</div>
</template>

<script>
import Roles from './Roles.vue'
import PermissionsSettings from './PermissionsSettings.vue'

export default {
	name: 'RolesPermissionsSettings',
	components: { Roles, PermissionsSettings },
	data() {
		return {
			sub: 'roles',
		}
	},
}
</script>
